<!-- 
Модалка с формой




 -->
<template>
    <div class="i-modal-form">
        <modal :name="`${name}-modal`" :width="width" :height="height" :title="title" @open="onOpen">
            <i-form 
            	:scheme="scheme" 
            	:value="value" 
            	:padding="8" 
            	:name="`${name}-form`" 
            	:changedOnly="true"
            	@input="save" 
            	@changed="(v)=>formChanged=v" 
            />
            <modal-control-buttons 
            	:disabledSave="!formChanged" 
            	:formName="`${name}-form`" 
            	slot="footer" 
            	:showRemove="showRemove" 
            	@remove="remove" 
            />
        </modal>
    </div>
</template>
<script>
import Modal from "../desktop/modal.vue";
import iForm from "./i-form.vue";
import ModalControlButtons from "./i-modal-control-buttons.vue";
export default {
    name: 'i-modal-form',
    methods: {
    	onOpen(){
            this.formChanged = false;
    	},
        save(item) {
        	if(this.extraData){
        		item = Object.assign({}, item, this.extraData)
        	}
        	if(this.value&&this.value._id){
        		item._id = this.value._id;
        	}

            if (this.$store && this.action) {
                this.$store.dispatch(this.action + 'Save', item);
            }
            this.$emit('input', item);
            if(this.closeOnSave){
            	this.closeModal(this.name+"-modal");
            }

            this.formChanged = false;
        },
        remove() {
            if (this.$store && this.action) {
                this.$store.dispatch(this.action + 'Remove', this.value._id);
            }
            this.$emit('remove', this.value._id);
            this.formChanged = false;
        }
    },
    components: {
        iForm,
        Modal,
        ModalControlButtons
    },
    props: {
        action: { type: String },
        title: { type: String },
        name: { type: String, required: true },
        scheme: { type: Object },
        height: { type: Number },
        width: { type: Number },
        value: { type: Object },
        extraData: { type: Object },
        showRemove: { type: Boolean, default: true },
        closeOnSave: { type: Boolean, default: true },

    },
    data() {
        return {
            formChanged: false
        }
    }
}
</script>
<style lang="css" scoped>
</style>